import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { TrackImpressionDirective } from '@analytics/events';

import type { ComposableCardConfig } from '../composables/card/card.model';
import { getComposableCardConfigFromRendering } from '../composables/card/card.model';
import type { ListConfig } from './list.model';
import { getListConfigFromRendering } from './list.model';
import { ListVariantHubComponent } from './variants/list-variant-hub/list-variant-hub.component';
import { ListVariantStepByStepComponent } from './variants/list-variant-step-by-step/list-variant-step-by-step.component';
import { ListVariantMinimalComponent } from './variants/list-variant-minimal/list-variant-minimal.component';

@Component({
  selector: 'wl-list-container',
  templateUrl: './list-container.component.html',
  styleUrls: ['./list-container.component.scss'],
  standalone: true,
  imports: [
    ListVariantHubComponent,
    TrackImpressionDirective,
    ListVariantStepByStepComponent,
    ListVariantMinimalComponent,
  ],
})
export class ListContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  listConfig?: ListConfig;
  cardConfig?: ComposableCardConfig;

  ngOnInit() {
    if (this.rendering) {
      this.listConfig = getListConfigFromRendering(this.rendering);
      this.cardConfig = getComposableCardConfigFromRendering(this.rendering);
    }
  }
}
